<template>
  <v-menu>
    <template v-slot:activator="{ on }">
      <v-btn text icon v-on="on"><v-icon class="mr-1">fas fa-key</v-icon></v-btn>
    </template>
    <v-card>
      <v-toolbar color="primary lighten-1" dark>
        <v-toolbar-title><v-icon>fas fa-key</v-icon> Key</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon>
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-list>
        <v-list-item>
          <v-list-item-avatar>
            <v-icon color="red">fas fa-user-slash</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>Not registered</v-list-item-title>
            <v-list-item-subtitle>the referral has not signed up for an account</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item>
          <v-list-item-avatar>
            <v-icon color="purple">fa-shipping-fast</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>Auto-send enquiries</v-list-item-title>
            <v-list-item-subtitle
              >enquiries will be automatically submitted to lenders on behalf of the customer</v-list-item-subtitle
            >
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item>
          <v-list-item-avatar>
            <abf-question-completion-gauge :question_completion_percentage="75"></abf-question-completion-gauge>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>Percentage of questions answered</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item>
          <v-list-item-avatar>
            <v-avatar size="24" small color="light-blue" class="white--text">2</v-avatar>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>Number of accepted enquires</v-list-item-title>
            <v-list-item-subtitle>enquiries being reviewed by a finance provider</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item>
          <v-list-item-avatar>
            <v-avatar size="24" small color="green" class="white--text">2</v-avatar>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>Number of funded enquires</v-list-item-title>
            <v-list-item-subtitle
              >enquiries being that have received funding or funding has been offered</v-list-item-subtitle
            >
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item>
          <v-list-item-avatar>
            <v-avatar size="24" small color="amber" class="white--text">2</v-avatar>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>Number of offers rejected</v-list-item-title>
            <v-list-item-subtitle>Number of enquiries with funding offered, but rejected by SME</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item>
          <v-list-item-avatar>
            <v-avatar size="24" small color="red" class="white--text">2</v-avatar>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>Number of cancelled enquires</v-list-item-title>
            <v-list-item-subtitle>enquiries cancelled by either the SME or finance provider</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item>
          <v-list-item-avatar>
            <v-avatar size="24" small color="grey" class="white--text">2</v-avatar>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>Number of pending enquires</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item>
          <v-list-item-avatar>
            <v-avatar size="24" small color="grey" class="strikethrough">2</v-avatar>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>Number of expired enquires</v-list-item-title>
            <v-list-item-subtitle>enquiries being that have not received a response</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
import AbfQuestionCompletionGauge from '../../../Abf/AbfQuestionCompletionGauge';
export default {
  name: 'ReferralKey',
  components: { AbfQuestionCompletionGauge }
};
</script>

<style lang="scss" scoped>
::v-deep {
  .strikethrough {
    text-decoration: line-through;
  }
}
</style>
